<template>
  <div class="d-inline-flex my-2 mr-2 align-center align-self-center file-item">
    <a :href="createOpenLink" class="pa-1" target="_blank" :title="file.display">{{ fileName }}</a>
    <v-btn
      v-if="showDeleteStatus"
      @click="$emit('on-delete')"
      class="ml-2 p-0"
      icon
      color="red"
    >
      <v-icon>mdi-delete</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'SingleFileItem',
  props: ['file', 'showDelete'],
  computed: {
    showDeleteStatus() {
      return typeof this.showDelete === 'string' || this.showDelete === true
    },
    createOpenLink() {
      if (!this.file || !this.file.full) return '#'
      return this.isOfficeFile(this.file.full)
        ? this.officeViewerUrl(this.file.full)
        : this.file.full
    },
    fileName() {
      if (!this.file || !this.file.display) return ''
      return this.truncate(this.file.display, 30)
    }
  },
  methods: {
    truncate(source, size) {
      return source.length > size ? source.slice(0, size - 1) + '...' : source
    },
    isOfficeFile(url) {
      const officeExtensions = [
        'doc',
        'docx',
        'dotx',
        'rtf',
        'odt',
        'xls',
        'xlsx',
        'xlsb',
        'xlsm',
        'xltx',
        'xltm',
        'ods',
        'ppt',
        'pptx',
        'pps',
        'ppsx',
        'odp',
        'csv',
        'txt'
      ]
      const ext = url.split('.').pop().toLowerCase().split('?')[0].split('#')[0]
      return officeExtensions.includes(ext)
    },
    officeViewerUrl(url) {
      return (
        'https://view.officeapps.live.com/op/view.aspx?src=' +
        encodeURIComponent(url)
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.file-item {
  border: 1px solid #4287f5;
  border-radius: 5px;
  a {
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
    opacity: 0.8;
  }
}
</style>
